
export default function(state=null,action){
    switch (action.type) {
      case "DELAY_ORDER":
          return action.payload;
      default: return state;
    }
  }
  


// WEBPACK FOOTER //
// ./src/reducer/get_delay_orders.js